var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mini-plan"},[_c('img',{attrs:{"src":_vm.IMG_URL + 'mini-building.png',"alt":""}})])}
var staticRenderFns = []

export { render, staticRenderFns }